import { css } from '@emotion/core'

export default ({ theme }) => css`
  display: flex;
  justify-content: center;
  padding: 1rem;

  .prev-button,
  .next-button,
  .currentPage {
    display: inline;
    margin: 0.2rem;
  }

  .currentPage {
    font-weight: bold;
  }

  .paginate-text {
    padding: 0 2rem;
  }

  .disabled {
    opacity: 0.25;
    pointer-events: none;
  }

  .page-count {
    margin: 0 2rem;
  }

  .page-count-prefix {
    texttransform: uppercase;
  }
`
